import { queryGet } from '@/api/apiConfig';

export default {
  getColors () {
    return queryGet('/api/app/color/');
  },

  getSpecialColors (schoolId) {
    return queryGet(`/api/app/school/schoolSyncDetails/${schoolId}`);
  },
};
